import React, { ChangeEvent, useCallback } from 'react';

import { Checkbox, GridLegacy as Grid, InputLabel, Typography } from '@mui/material';

import { REGION_REPLICATION_MAP } from '~/consts/regionReplication';

interface RegionToggleProps {
  initialEnabledRegion: string;
  enabledRegions: Array<string>;
  onRegionsChange: (regions: Array<string>) => void;
}

function RegionToggle({ initialEnabledRegion, enabledRegions, onRegionsChange }: RegionToggleProps) {
  const handleToggle = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const region = e.target.id.replace('checkbox_', '');
      const newEnabledRegions = enabledRegions.includes(region)
        ? enabledRegions.filter((r) => r !== region)
        : [...enabledRegions, region];

      onRegionsChange(newEnabledRegions);
    },
    [enabledRegions, onRegionsChange],
  );

  if (!REGION_REPLICATION_MAP[initialEnabledRegion]) {
    return null;
  }
  const replicationRegions = REGION_REPLICATION_MAP[initialEnabledRegion];
  return (
    <Grid container item xs gap={2} alignItems="center">
      <Grid item>
        <Typography>Apply also to: </Typography>
      </Grid>
      {replicationRegions.map((region) => (
        <Grid key={region} item>
          <Grid container gap={1} alignItems="center">
            <InputLabel htmlFor="checkbox-nsw">{region}</InputLabel>
            <Checkbox id={'checkbox_' + region} checked={enabledRegions.includes(region)} onChange={handleToggle} />
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
}

export default RegionToggle;
